/**
 * 系统内置静态资源URL定义
 */

/* prettier-ignore */ // 默认分享图片
export const DEFAULT_SHARE_IMAGE = 'https://cnstatic01.e.vhall.com/common-static/images/ebc0f189b199.jpg';

/* prettier-ignore  */ // 个人主页默认banner图
export const DEFAULT_USER_HOME_BANNER = 'https://cnstatic01.e.vhall.com/common-static/images/ebc804a7802.png';

/* prettier-ignore  */ // 默认用户头像
export const DEFAULT_AVATAR =  'https://cnstatic01.e.vhall.com/common-static/images/default_avatar.png';
